export enum EXPECTS {
  ADDITIONAL_INFORMATION_NEEDED = 'AdditionalInformationNeeded',
  ANSWER_QUOTATION = 'AnswerQuotation',
  AUTO_GENERATE_REFUND_BARCODES = 'Auto_GenerateRefundBarcodes',
  CARRIER_OUTSIDE_SYSTEM = 'CarrierOutsideSystem',
  CHOOSE_ACTOR = 'ChooseActor',
  CHOOSE_ANY_ACTOR = 'ChooseAnyActor',
  COLLECT_BANK_ACCOUNT_DETAILS = 'CollectBankAccountDetails',
  COLLECT_PAYMENT_AT_HOME = 'CollectPaymentAtHome',
  COLLECT_PAYMENT_AT_STORE = 'CollectPaymentAtStore',
  COMMERCIAL_SOLUTION = 'Solcom',
  CONFORMITY_RECEPTION = 'ConformityReception',
  CREATE_VIDEO_CALL = 'CreateVideoCall',
  EDIT_INTERVENTION_REPORT = 'EditInterventionReport',
  EXPECT_AWAITING_ACCOUNT_DESACTIVATION = 'UnlinkDevice',
  EXPECT_AWAITING_PAYMENT = 'Payment',
  EXPECT_DOCUMENTS_NEEDED = 'DocumentsNeeded',
  EXPECT_FORCE_CLOSE_FILE = 'ForceCloseFile',
  EXPECT_ISSUE_QUOTE = 'EditQuote',
  EXPECT_TAKE_APPOINTMENT = 'TakeAppointment',
  EXPECT_TAKE_INTERVENTION_APPOINTMENT = 'TakeInterventionAppointment',
  EXPECT_UNLOCK_CODE_REQUESTED = 'DevicePassword',
  ISSUE_A_QUOTATION = 'IssueAQuotation',
  ISSUE_A_PAYMENT = 'IssueAPayment',
  MAKE_COMMERCIAL_GESTURE = 'MakeCommercialGesture',
  MAKE_PAYMENT_REFUND = 'MakePaymentRefund',
  MAKE_MARKETING_OFFER = 'MakeMarketingOffer',
  MARK_SPARE_PARTS_REQUEST_AS_DELIVERED = 'MarkSparePartRequestAsDelivered',
  OWNER_ADDRESS_CORRECTION = 'OwnerAddressCorrection',
  POSTPONE_FSL_SCHEDULE = 'PostponeFslSchedule',
  PRODUCT_ADEQUACY = 'ProductAdequacy',
  QUOTATION_EXTERNAL = 'Quotation_External',
  QUOTATION_INTERNAL = 'Quotation_Internal',
  RDV_CONFORMITY = 'rdc_conformite',
  REFUND = 'Refund',
  REJECT_SOLUTION = 'RejectSolution',
  REJECT_WARRANTY = 'RejectWarranty',
  SELECT_WORK_TYPE_INTERVENTION = 'SelectWorkTypeIntervention',
  SELLER_PROVIDED_CARRIER_LABEL_REQUIRED = 'SellerProvidedCarrierLabelRequired',
  SPARE_PART_REQUEST = 'SparePartRequest',
  UNUSED_SPARE_PARTS = 'UnusedSpareParts',
  EXPLODE_REQUIRED = 'ExplodeRequired',
  DECLARE_FRAUD = 'DeclareFraud',
  CANCEL_FRAUD = 'CancelFraud',
  SIGNATURE_REQUIRED = 'SignatureRequired',
}
